<template>
  <div class="home">
    <br/>
    <cube-button @click="toPage('/tax/personal')">税收文件 - 自然人</cube-button>
    <br/>
    <cube-button @click="toPage('/tax/org')">税收文件 - 机构</cube-button>
    <br/>
    <cube-button @click="$_handleActions(1)">风险测评</cube-button>
    <br/>
    <cube-button @click="$_handleActions(2)">自然人投资者信息</cube-button>
    <br/>
    <cube-button @click="$_handleActions(3)">机构投资者信息</cube-button>
    <br/>
    <cube-button @click="$_handleActions(4)">产品买产品投资者信息</cube-button>
    <br/>
    <cube-button @click="$_handleActions(5)">操作手册</cube-button>
    <br/>
    <cube-button @click="$_handleActions(6)">下载</cube-button>
    <br/>
    <cube-button @click="$_handleActions(7)">妥妥递隐私权政策</cube-button>
    <br/>
    <cube-button @click="$_handleActions(8)">用户注册与使用协议</cube-button>
    <br/>
    <cube-button @click="$_handleActions(9)">管理系统网络服务协议</cube-button>
    <br/>
    <cube-button @click="$_handleActions(10)">数字证书申请验证</cube-button>
    <br/>
    <cube-button @click="toPdfView">pdf预览</cube-button>
  </div>
</template>

<script>
// @ is an alias to /src
// import { getUserLogin, getUserRelationManager, getManagerUserInfo } from '../api/user';

export default {
  name: 'home',
  mounted() {
    console.log(process.env.NODE_ENV);
  },
  methods: {
    $_handleActions(type) {
      if (type === 1) {
        this.$router.push({ path: '/risk' });
      }
      if (type === 2) {
        this.$router.push({ path: '/natural' });
      }
      if (type === 3) {
        this.$router.push({ path: '/corporate' });
      }
      if (type === 4) {
        this.$router.push({ path: '/product' });
      }
      if (type === 5) {
        this.$router.push({ path: '/guide' });
      }
      if (type === 6) {
        this.$router.push({ path: '/download' });
      }
      if (type === 7) {
        this.$router.push({ path: '/privacy' });
      }
      if (type === 8) {
        this.$router.push({ path: '/register' });
      }
      if (type === 9) {
        this.$router.push({ path: '/protocol' });
      }
      if (type === 10) {
        this.$router.push({ path: '/verifiy/3842' });
      }
    },
    toPage(path) {
      this.$router.push(path);
    },
    toPdfView() {
      window.location.href = `${window.location.origin}/pdfviewer/web/viewer.html`;
    },
  },
};
</script>

<style lang="scss" scoped>
  .home {
    padding: 0 20px;
  }

</style>
